<template>
  <div>
    <b-card class="card-custom" header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <div class="card-title">
          <h3 class="card-label">
            {{ $t("STOCK_AVERAGE_COST_LIST") }}
            <i class="mr-2"></i>
            <small class="">{{ $t("LIST") }}</small>
          </h3>
        </div>
        <div class="card-toolbar"></div>
      </template>
      <v-card v-show="!isPageLoading">
        <SearchTools
          :searchQuery.sync="searchQuery"
          @do-search="doSearch"
          @do-clear="doClear"
        >
          <template v-slot:prepend>
            <b-col :lg="3" :md="12" v-if="!isPageLoading && _.size(stores) > 0">
              <v-autocomplete
                :items="stores"
                :label="$t('STORE')"
                item-text="name"
                item-value="id"
                hide-details
                v-model="filters.storeId"
                @click:clear="clearFilter('storeId')"
              ></v-autocomplete>
            </b-col>
            <b-col :lg="3" :md="12" v-if="!isPageLoading && _.size(stores) > 0">
              <FormDatepickerBase
                :type="'text'"
                :clearable="true"
                :i18n="{
                  label: 'DATE'
                }"
                :date.sync="filters.date"
              ></FormDatepickerBase>
            </b-col>
          </template>
        </SearchTools>
        <v-data-table
          v-if="_.size(stores) > 0 && filters.storeId != null"
          :headers="tableHeaders"
          :items="items"
          :options.sync="options"
          :items-per-page="totalItems"
          :server-items-length="totalItems"
          sort-by="forDate"
          sort-desc="true"
          :loading="isLoadingStock"
          loading-text="Loading... Please wait"
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageOptions: rowsPerPageItems,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            itemsPerPageText: $t('ITEMS_PER_PAGE_TEXT')
          }"
          @update:options="getDataFromApi()"
          class="elevation-1"
        >
          <template v-slot:item.avgCost.cost="{ item }">
            {{ item.avgCost.cost }}
          </template>
          <template v-slot:item.actions="{ item }">
            <router-link
              v-if="checkIfUserHasPermission(['stock-actions-show'])"
              :to="{ name: 'stock-action-review', params: { id: item.id } }"
            >
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-2" fab dark x-small v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-format-list-bulleted</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("VIEW") }}</span>
              </v-tooltip>
            </router-link>
            <template v-else>No Action Rights</template>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ searchQuery }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <v-skeleton-loader
        v-if="isPageLoading"
        :loading="isPageLoading"
        type="table"
      ></v-skeleton-loader>

      <v-overlay :value="!firstLoader && isLoadingSharedStore">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <template v-slot:footer></template>
    </b-card>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";
import SearchTools from "@/core/components/table/SearchTools.vue";

//Audit Module
import {
  FETCH_STOCK_AVG_COSTS,
  APPLY_SINGLE_STOCK_ACTION_AVG_COST
} from "@/modules/stock/store/stock.module";

import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";

import { FETCH_STORES_BASIC } from "@/core/services/store/shared_store.module";

//Shared Modules
import { FETCH_SELECTS_BASIC } from "@/core/services/store/shared_base.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

export default {
  name: "StockAvgCostList",
  mixins: [permissionMixin],
  data() {
    return {
      firstLoader: true,
      isPageLoading: true,
      items: [],
      stores: [],
      dates: [],
      totalItems: 100,
      allItemsTotalPriceSum: 0,
      searchQuery: "",
      filters: {
        storeId: null,
        date: null
      },
      options: {
        descending: true,
        page: 1,
        itemsPerPage: 10,
        totalItems: 100
      },
      stockActionTypes: [],
      rowsPerPageItems: [10, 20, 30, 40, 50],
      columns: {},
      cancelSource: null,
      selectedItemId: null,
      headers: [
        {
          text: this.$t("ID"),
          align: "start",
          filterable: true,
          value: "id"
        },
        {
          text: this.$t("ECHO ID"),
          align: "start",
          filterable: true,
          value: "echoId"
        },
        {
          text: this.$t("CODE"),
          align: "start",
          filterable: true,
          value: "code"
        },
        {
          text: this.$t("ITEM"),
          align: "start",
          filterable: true,
          value: "name"
        },
        {
          text: this.$t("ITEM_TYPE"),
          align: "start",
          filterable: true,
          value: "itemTypeName"
        },
        {
          text: this.$t("UPDATED_AT"),
          align: "start",
          filterable: true,
          value: "avgCost.lastUpdatedAt",
          sortable: false
        },
        {
          text: this.$t("CURRENCY"),
          align: "right",
          filterable: true,
          value: "avgCost.currencyCode",
          sortable: false
        },
        {
          text: this.$t("LAST_STOCK_AVERAGE_COST"),
          align: "right",
          filterable: true,
          value: "avgCost.cost",
          sortable: false
        }
      ]
    };
  },
  components: {
    FormDatepickerBase,
    SearchTools
  },
  watch: {
    storesParams() {
      let vm = this;
      vm.filters.storeId = null;
      vm.filters.date = null;
    }
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock Actions", route: { name: "stock-actions-list" } },
      { title: "Stock Actions List" }
    ]);

    // vm.getSelects();
    vm.getStores();
  },
  computed: {
    ...mapGetters([
      "getItems",
      "isLoadingStock",
      "isLoadingSharedStore",
      "currentUser"
    ]),
    params() {
      return {
        ...this.options,
        query: this.searchQuery,
        storeId: this.filters.storeId,
        date: this.filters.date
      };
    },
    storesParams() {
      let storesParams = {};
      return storesParams;
    },
    tableHeaders() {
      let vm = this;
      return vm.headers;
    }
  },
  methods: {
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function() {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    doClear() {
      let vm = this;
      vm.searchQuery = "";
      vm.filters.storeId = null;
      vm.filters.date = null;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    getDataFromApi() {
      let vm = this;
      //copy current params to modify
      let params = this.params;

      params.length = params.itemsPerPage; //set how many records to fecth per page
      params.start =
        params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
      // console.log(this.params);
      let apiParams = vm.transformUrlParams(params);
      // console.log(apiParams);
      vm.$store
        .dispatch(FETCH_STOCK_AVG_COSTS, apiParams)
        .then(data => {
          // vm.$notify({
          //   group: "notify",
          //   type: "success",
          //   title: "<i class='flaticon2-checkmark'></i> Success",
          //   text: data.message
          // });
          vm.$nextTick(function() {
            vm.items = data.data.items;
            vm.totalItems = data.data.totalItemsCount;

            if (vm.isPageLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-actions-list" });
          }
        });
    },
    getStores() {
      let vm = this;
      let params = this.storesParams;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_STORES_BASIC, apiParams)
        .then(data => {
          this.$set(vm, "stores", data.data);
          vm.filters.storeId = data.data[0].id;
          vm.$nextTick(function() {
            vm.firstLoader = false;
            if (vm.isPageLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
        });
    },
    getSelects() {
      let vm = this;
      let payload = {};
      this.$store
        .dispatch(FETCH_SELECTS_BASIC, payload)
        .then()
        .catch(response => {
          console.log(response);
        })
        .finally(function() {
          vm.firstLoader = false;
          if (vm.isPageLoading == true) {
            vm.isPageLoading = false;
          }
        });
    },
    applySingleActionAvgCost(item, applyAllStores) {
      let vm = this;
      let payload = {
        cost: item.avgCost.cost,
        storeId: vm.filters.storeId,
        applyAllStores: applyAllStores
      };
      this.$store
        .dispatch(APPLY_SINGLE_STOCK_ACTION_AVG_COST, {
          id: item.id,
          payload: payload
        })
        .then(data => {
          vm.errors = data.data.errors;
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          vm.selectedItemId = null;
        })
        .catch(function(response) {
          vm.errors = response.data.errors;
          vm.$notify({
            group: "notify",
            type: "error",
            title: "Error",
            text: response.data.message
          });
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
